import React, {useState} from 'react';
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import showQuestionIcon from "../../assets/question-circle.svg";
import {FormattedMessage} from "react-intl";

const styledValues = {
  underline: str => <span className={styles.underline}>{str}</span>,
  bold: str => <span className={styles.bold}>{str}</span>,
  br: <br/>,
}

const QABlock = ({
                   question,
                   answer,
                 }) => {
  const [answerShow, setAnswerShow] = useState(false);

  return (
    <div className={styles.questionAnswerUnit}>
      <div
        className={styles.questionUnit}
        data-testid="btn-show-hide-answer"
        onClick={() => {
          setAnswerShow(prevState => !prevState)
        }}
      >
        <img
          src={showQuestionIcon}
          alt="showQuestionIcon"
          className={styles.questionUnitIcon}
        />
        <div className={styles.questionUnitLabel}>
          <FormattedMessage id='qw-1' defaultMessage={question} values={styledValues}/>
        </div>
      </div>
      {answerShow &&
      <div className={styles.answerUnit}>
        <div>
          <FormattedMessage id='answ-1' defaultMessage={answer[0]} values={styledValues}/>
          <div className={styles.paddingRight}>
            <ul className={styles.paddingRight}>
              {answer.slice(1, answer.length).map((answer, index) => (
                <li key={index}>{answer}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>}
    </div>
  );
};

QABlock.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  containerCustomStyles: PropTypes.string
};

export default QABlock;
